import styled from '@emotion/styled';
import { Button, ButtonProps } from 'antd';

import { ArrowIcon } from '../Icon';

interface StyledButtonProps extends ButtonProps {
  collapsed: string;
}

const StyledButton = styled(Button)<StyledButtonProps>`
  position: absolute;
  inset-block-start: 40px;
  inset-inline-end: -12px;
  > svg {
    transition: transform 0.3s;
    transform: rotate(90deg);
    transform: ${({ collapsed }) =>
      `rotate(${collapsed === 'true' ? -90 : 90}deg)`};
  }
`;

interface SiderArrowProps {
  onClick: () => void;
  collapsed: boolean;
}

export const SiderArrow: React.FC<SiderArrowProps> = ({
  onClick,
  collapsed,
}) => {
  return (
    <StyledButton
      collapsed={String(collapsed)}
      type="primary"
      shape="circle"
      size="small"
      onClick={onClick}
    >
      <ArrowIcon />
    </StyledButton>
  );
};
